<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-14 14:34:01
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2022-12-14 11:01:07
 * @FilePath: \sns-user-frontend\src\components\borderLine.vue
 * @Description: 
-->
<template>
  <div class="border-line"></div>
</template>

<script setup>

</script>

<style lang="postcss" scoped>
.border-line {
  position: relative;
  width: 100%;
  &:after {
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    content: " ";
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: scaleY(0.33);
    transform: scaleY(0.33);
    border-bottom: 1px solid var(--line);
  }
}
</style>